import React from 'react';
import { AlertTriangle, Zap, X, ArrowRight } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const TrialExpiredModal = ({ isOpen, onClose, onUpgrade }) => {
  const { theme } = useTheme();

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '20px'
    }}>
      <div style={{
        background: theme.colors.bg.primary,
        borderRadius: '24px',
        maxWidth: '500px',
        width: '100%',
        padding: '40px',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
        border: `1px solid ${theme.colors.border.primary}`,
        position: 'relative'
      }}>
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            color: theme.colors.text.secondary,
            padding: '8px'
          }}
        >
          <X size={20} />
        </button>

        {/* Warning Icon */}
        <div style={{
          width: '80px',
          height: '80px',
          background: 'linear-gradient(135deg, rgba(251, 191, 36, 0.2) 0%, rgba(245, 158, 11, 0.1) 100%)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px'
        }}>
          <AlertTriangle size={40} style={{ color: '#fbbf24' }} />
        </div>

        {/* Title */}
        <h2 style={{
          fontSize: '1.75rem',
          fontWeight: '700',
          color: theme.colors.text.primary,
          marginBottom: '12px'
        }}>
          Your Free Trial Has Ended
        </h2>

        {/* Subtitle */}
        <p style={{
          fontSize: '1rem',
          color: theme.colors.text.secondary,
          marginBottom: '32px',
          lineHeight: '1.6'
        }}>
          Your 7-day free trial has expired. Upgrade now to continue optimizing your Google Ads campaigns and unlock all features.
        </p>

        {/* Benefits */}
        <div style={{
          background: theme.colors.bg.secondary,
          borderRadius: '12px',
          padding: '20px',
          marginBottom: '32px',
          textAlign: 'left'
        }}>
          <p style={{
            fontSize: '0.875rem',
            fontWeight: '600',
            color: theme.colors.text.primary,
            marginBottom: '12px'
          }}>
            What you'll get with a paid plan:
          </p>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          }}>
            {[
              'Unlimited campaign optimizations',
              'AI-powered bid recommendations',
              'Quality Score improvements',
              'Priority support'
            ].map((benefit, i) => (
              <li key={i} style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '0.875rem',
                color: theme.colors.text.secondary
              }}>
                <Zap size={14} style={{ color: '#10b981' }} />
                {benefit}
              </li>
            ))}
          </ul>
        </div>

        {/* CTA Button */}
        <button
          onClick={onUpgrade}
          style={{
            width: '100%',
            padding: '16px 24px',
            background: 'linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 20px rgba(139, 92, 246, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          View Pricing Plans
          <ArrowRight size={18} />
        </button>

        {/* Secondary text */}
        <p style={{
          fontSize: '0.75rem',
          color: theme.colors.text.muted,
          marginTop: '16px'
        }}>
          Plans start at €99/month • Cancel anytime
        </p>
      </div>
    </div>
  );
};

export default TrialExpiredModal;
